import labelStyles from '../labels/styles.less';
import { Observable, Scheduler, Subject } from '@reactivex/rxjs';

const debug =           (...args) => {}
// import { sprintf as printf } from 'sprintf-js';
// const debug =           (...args) => console.log(`       StreamGL:interaction:`, printf(...args));

/*
    shift left/right: rotate
    shift up/down: tilt
*/
// Camera -> Observable Camera
// feature-gated by 3d
export function setupRotate(target, camera) {
    var CODES = { LEFT: 37, UP: 38, RIGHT: 39, DOWN: 40 };
    var AMT = 5;

    return Observable.fromEvent(target, 'keydown')
        .filter(function() {
            return camera.is3d;
        })
        .filter(function(e) {
            return !!e.shiftKey;
        })
        .do(function(e) {
            switch (e.keyCode || e.which) {
                case CODES.LEFT:
                    camera.rotation.z = (camera.rotation.z + AMT) % 360;
                    break;
                case CODES.UP:
                    camera.rotation.x = (camera.rotation.x + AMT) % 360;
                    break;
                case CODES.RIGHT:
                    camera.rotation.z = (camera.rotation.z - AMT) % 360;
                    break;
                case CODES.DOWN:
                    camera.rotation.x = (camera.rotation.x - AMT) % 360;
                    break;
            }
        })
        .mapTo(camera);
}

export function setupZoomButton(toggleZoom, camera, zoomFactor) {
    return toggleZoom.map(() => zoom(camera, zoomFactor));
}

export function setupCenter(toggleCenter, camera) {
    return toggleCenter.map(({ xRatio = 1, yRatio = 1, boundBox } = {}) => {
        if (!boundBox) return camera;
        debug('centering %j', boundBox);
        // ordered in CSS property order
        const [top, right, bottom, left] = boundBox;
        return camera.centerOn(
            left, right, top, bottom, xRatio, yRatio
        );
    }).auditTime(0, Scheduler.animationFrame);
}

// Camera * Float * {x : Float, y: Float}
// Zoom in/out on zoomPoint (specified in screen coordinates)
export function zoom(camera, zoomFactor, zoomPoint) {
    var xoffset = 0;
    var yoffset = 0;
    if (zoomPoint !== undefined) {
        xoffset = zoomPoint.x - camera.center.x;
        yoffset = zoomPoint.y - camera.center.y;
    }

    camera.center.x += xoffset * (1.0 - zoomFactor);
    camera.center.y += yoffset * (1.0 - zoomFactor);
    camera.zoom = camera.zoom * zoomFactor;
    camera.width = camera.width * zoomFactor;
    camera.height = camera.height * zoomFactor;

    debug(
        'New Camera center=(%f, %f) size=(%f , %f)',
        camera.center.x,
        camera.center.y,
        camera.width,
        camera.height
    );

    return camera;
}
